// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export const Complete: React.FunctionComponent<any> = ({ ...props }) => {
    return (
        <SvgIcon width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
            <path
                d="M5.99996 11.8327C2.77821 11.8327 0.166626 9.2211 0.166626 5.99935C0.166626 2.7776 2.77821 0.166016 5.99996 0.166016C9.22171 0.166016 11.8333 2.7776 11.8333 5.99935C11.8333 9.2211 9.22171 11.8327 5.99996 11.8327ZM5.32563 8.6156L9.44979 4.49085L8.62496 3.66602L5.32563 6.96593L3.67538 5.31568L2.85054 6.14052L5.32563 8.6156Z"
                fill="#4AA06B"
            />
        </SvgIcon>
    );
};
